import * as Type from './actionsTypes';
import {
  RELATORIO_JOB_MENU_SIZE,
  isRelatorioJobInFlight,
} from '../../helpers/relatorioJob';

const INITIAL_STATE = {
  items: [],
  totalElements: 0,
  downloadingId: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.RELATORIO_JOB_FETCH_PREVIEW_SUCCESS: {
      const incoming = action.items || [];
      const incomingIds = incoming.reduce((acc, item) => {
        if (item && item.id) acc[item.id] = true;
        return acc;
      }, {});
      const pendingLocal = (state.items || []).filter(
        (job) => isRelatorioJobInFlight(job.status) && job.id && !incomingIds[job.id]
      );
      const items = [...pendingLocal, ...incoming].slice(0, RELATORIO_JOB_MENU_SIZE);
      return {
        ...state,
        items,
        totalElements: Math.max(action.totalElements || 0, items.length),
      };
    }
    case Type.RELATORIO_JOB_START_SUCCESS: {
      const next = action.job;
      if (!next || !next.id) return state;
      const rest = (state.items || []).filter((item) => item.id !== next.id);
      const items = [next, ...rest].slice(0, RELATORIO_JOB_MENU_SIZE);
      return {
        ...state,
        items,
        totalElements: Math.max(state.totalElements, 1, items.length),
      };
    }
    case Type.RELATORIO_JOB_DOWNLOAD:
      return {
        ...state,
        downloadingId: action.job && action.job.id ? action.job.id : null,
      };
    case Type.RELATORIO_JOB_DOWNLOAD_DONE:
      return {
        ...state,
        downloadingId: null,
      };
    case Type.RELATORIO_JOB_CLEAN:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export const getRelatorioJobItems = (state) => state.rootState.relatorioJob.items;
export const getRelatorioJobTotal = (state) => state.rootState.relatorioJob.totalElements;
export const getRelatorioJobInFlightCount = (state) =>
  (state.rootState.relatorioJob.items || []).filter((job) => isRelatorioJobInFlight(job.status)).length;
export const getRelatorioJobDownloadingId = (state) => state.rootState.relatorioJob.downloadingId;
